import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ViewInfoModel } from '../engine/models/view.tree-node';
import { ViewContentSourceEnum } from '../view/models/view-content-source.enum';

@Injectable({
  providedIn: 'root',
})
export class ContentInfoService {
  private nodeInfoCache = new Map<string, ViewInfoModel>();

  constructor(private http: HttpClient) {}

  queryNodeInfo(
    name: string,
    fallback: ViewContentSourceEnum,
    lang: string = 'en',
    fromCache = true,
  ): Observable<ViewInfoModel> {
    // Note: for offline builds (no services available), always return empty response
    if (environment.offline) {
      return of(undefined);
    }

    // note: custom mapping of query params
    const plan = fallback === ViewContentSourceEnum.Wikipedia ? 'wiki' : fallback;
    const url = `/search/descriptions?name=${name}&plan=${plan}&ol=${lang}`;
    const cacheKey = url;

    if (fromCache && this.nodeInfoCache.has(cacheKey)) {
      // read from cache
      const nodeInfo = this.nodeInfoCache.get(cacheKey);
      return of(nodeInfo);
    } else {
      // live request
      return this.http.get(url).pipe(
        // get description
        map((response: any) => {
          return <ViewInfoModel>{
            label: name,
            latinLabel: response.latin_term,
            description: response.description,
            source: response.source,
            sourceLink: response.url,
          };
        }),
        // special case: catch + cache 404
        catchError((err: HttpErrorResponse) =>
          err.status === 404 ? of(undefined) : throwError(err),
        ),
        // add cache entry
        tap((viewInfo: ViewInfoModel) => this.nodeInfoCache.set(cacheKey, viewInfo)),
      );
    }
  }
}
